module.exports = __webpack_public_path__ + "img/bq.2186dd4f.png";